import {
  Box,
  Center,
  Container,
  Divider,
  Grid,
  GridItem,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";

import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

export default function ArtistGuidePage() {
  const { colorMode } = useColorMode();
  return (
    <>
      <Head>
        <title>Artist Guide | Songcards</title>
        <meta property="og:site_name" content="Songcards" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href="https://songcards.io/artist-guide" />
        <meta name="description" content="Listen. Discover. Collect." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" href="/SC Icon_A_Light.svg" />
        <link rel="icon" href="/SC Icon_A_Light.svg" />

        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/artist-guide" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Songcards" />
        <meta property="og:title" content="Artist Guide | Songcards" />
        <meta property="og:description" content="Listen. Discover. Collect." />
        <meta name="twitter:domain" content="songcards.io" />
        <meta name="twitter:site" content="@unlockyoursound" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Artist Guide | Songcards" />
        <meta name="twitter:description" content="Listen. Discover. Collect." />

        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
      </Head>
      <Container>
        <Heading>For Artists</Heading>
        <br />
        <Text>
          If you{`'`}re new to Songcards and want to get involved as an artist,
          the first step is to submit a song as a songcard.
        </Text>
        <br />
        <Text>
          Once your first songcard is approved, we{`'`}ll get you set up on the
          platform.
        </Text>
        <br />
        <Text>
          If you{`'`}re not quite ready, or have some questions, please don{`'`}
          t hesitate to get in touch.
        </Text>
        <br />
        <Text>
          New artists start{" "}
          <u>
            <a target="_blank" href="https://create.songcards.io">
              here
            </a>
          </u>
          .
        </Text>
        <br />
        <Text>
          Existing artists can access the portal{" "}
          <u>
            <a target="_blank" href="https://artists.songcards.io">
              here
            </a>
          </u>
          .
        </Text>
        <Divider mb={15} mt={5} />
        <Grid
          templateColumns={{ base: "1fr", sm: "repeat(3, 1fr)" }}
          gap={4}
          justifyContent="center"
        >
          <Link href="https://create.songcards.io" target="_blank">
            <GridItem>
              <Box
                borderWidth={1}
                borderRadius={30}
                borderColor={colorMode === "light" ? "black" : "white"}
                borderStyle={"dotted"}
                padding={3}
                textAlign="center"
              >
                Create a Songcard
              </Box>
            </GridItem>
          </Link>
          <Link href="mailto:chris@songcards.io">
            <GridItem>
              <Box
                borderWidth={1}
                borderRadius={30}
                borderColor={colorMode === "light" ? "black" : "white"}
                borderStyle={"dotted"}
                padding={3}
                textAlign="center"
              >
                Get in touch
              </Box>
            </GridItem>
          </Link>
          <Link
            href="https://unlockyoursound.substack.com/p/faqs-about-songcards?r=3hpxh&utm_campaign=post&utm_medium=web&triedRedirect=true"
            target="_blank"
          >
            <GridItem>
              <Box
                borderWidth={1}
                borderRadius={30}
                borderColor={colorMode === "light" ? "black" : "white"}
                borderStyle={"dotted"}
                padding={3}
                textAlign="center"
              >
                FAQs
              </Box>
            </GridItem>
          </Link>
        </Grid>
        <Center mb={300} mt={120}>
          <Link href={`/`}>
            <Image
              src={
                colorMode === "dark"
                  ? "/SC Icon_B_White.svg"
                  : "/SC Icon_B_Black.svg"
              }
              width={30}
              height={30}
              alt="Discover more Songcards"
            />
          </Link>
        </Center>
      </Container>
    </>
  );
}
//
